import { render, staticRenderFns } from "./ConsultationIndex.vue?vue&type=template&id=09fd83c2&scoped=true&"
import script from "./ConsultationIndex.vue?vue&type=script&lang=js&"
export * from "./ConsultationIndex.vue?vue&type=script&lang=js&"
import style0 from "./css/index.css?vue&type=style&index=0&id=09fd83c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd83c2",
  null
  
)

export default component.exports